// src/lib/map/liveMap.js
//
// A MapLibre map that may still be called: there, and not removed. MapLibre's
// remove() marks the map (_removed) and then fires "remove"; after that its
// style is gone and nearly every call (getSource, getLayer, setFeatureState)
// throws. Code holding a map that can be removed under it (Explore's compare
// map, REM-703) asks this before every call and drops the map on "remove".
export const isLiveMap = (map) => Boolean(map) && !map._removed;
